import { getCustomer } from '@api/customersApi';
import { useQuery } from 'api-hooks/hooks';
import { Loading } from '@components';
import Box from '@components/box/Box';
import { Col, Row } from 'antd';
import React from 'react';
import Field from '@components/field/Field';

type Props = {
  id: number;
};

const CustomerDetails: React.FC<Props> = ({ id }) => {
  const result = useQuery(getCustomer(id));

  return (
    <Loading
      {...result}
      errorDescription={() => 'Cannot load customer data'}
      minHeight={250}>
      {customer => (
        <Box
          header={customer.name}
          content={
            <Row>
              <Col span={4}>
                <Field name="LIMS ID" value={customer.lims} />
              </Col>
              <Col span={12}>
                <Field name="Customer Name" value={customer.name} />
              </Col>
              <Col span={8}>
                <Field name="Address" value={customer.address} />
              </Col>
              <Col span={6}>
                <Field name="City" value={customer.city} />
              </Col>
              <Col span={4}>
                <Field name="State" value={customer.state} />
              </Col>
              <Col span={4}>
                <Field name="Postal Code" value={customer.postal_code} />
              </Col>
              <Col span={4}>
                <Field name="Country" value={customer.country} />
              </Col>
            </Row>
          }
        />
      )}
    </Loading>
  );
};

export default CustomerDetails;
